module.exports = __webpack_public_path__ + "static/media/blue_man_doctor.8d4f0e5d.jpg";